import { Grid } from '@material-ui/core';
import React from 'react';

import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { IMenuList } from '~/src/dash/types/menuList';
import { publicaColors } from '~/src/dash/utils/colors';

interface IIASDashboardFiltersPillProps {
  menuTitle: string;
  list: IMenuList;
  handleFilterOnChange: (menuTitle: string) => (values: IMenuList) => void;
  tooltipText?: string;
  handleFilterAccept: () => void;
  trackEvent?: () => void;
}

export const IASDashboardFiltersPill = ({
  menuTitle,
  list,
  handleFilterOnChange,
  handleFilterAccept,
  trackEvent,
}: IIASDashboardFiltersPillProps) => {
  const numSelected = Object.values(list).filter((item) => item.selected).length;
  // TODO: add actual singular titles to a config here instead of just removing the 's'
  const singularTitle = menuTitle.slice(0, menuTitle.length - 1);

  return (
    <Grid
      style={{
        height: '100%',
        border: `1px solid ${publicaColors.lightGray}`,
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 12,
        paddingRight: 8,
        borderRadius: 25,
        backgroundColor: numSelected ? publicaColors.lightTeal : publicaColors.veryLightGray,
        maxWidth: 250,
      }}
    >
      <MaterialSearchDropdownMulti
        disabled={false}
        fontSize='12px'
        menuTitle={menuTitle}
        singularTitle={singularTitle}
        list={list}
        onChange={handleFilterOnChange(menuTitle)}
        handleMenuAcceptClick={handleFilterAccept}
        onlyShowNumberWhenClosed={true}
        maxHeight={350}
        selectAll={false}
        disableBottomBorder={true}
        onOpen={trackEvent}
      />
    </Grid>
  );
};
